<template>
    <div class="balance">
        <div class="row">  
            <div class="col-sm-12 col-md-12" :class="classShowDetails">
                <div class="row">
                    <div class="col-md-12 payment-records-Op" v-if="displayMethods">
                        <h5 class="mb-2" v-if="!hideDetails"><i class="las la-donate text-primary"></i> Formas de cobro</h5>
                        <div class="alert alert-info" v-if="disabledPayCash">
                            <small><i class="las la-bullhorn text-primary"></i> Para cobrar con tarjeta u otros medios, deberás configurar tu pasarela local de cobros. <router-link class="text-primary" :to="{name: 'my-charges'}">Configurar Cobros</router-link></small>
                        </div>
                        <!--<small class="fst-italic"><i class="las la-bullhorn text-primary"></i> Los pagos con tarjeta de debito o credito usarán los medios de pagos configurados en tu cuenta de usuario.</small>-->
                        <div class="form-check form-switch mb-3">
                            <input class="form-check-input" type="checkbox" id="creditCard" name="creditCard" v-model="payCardTurns" @change="updatePaymentOptions()" :disabled="disabledPayCard" style="width: 2em;">
                            <label class="form-check-label" for="creditCard">Puede abonar con tarjeta de crédito y debito</label>
                        </div> 
                        <div class="form-check form-switch mb-3">
                            <input class="form-check-input" type="checkbox" id="payCashTurns" name="payCashTurns" v-model="payMoneyTurns" @change="updatePaymentOptions()" :disabled="disabledPayMoney" style="width: 2em;">
                            <label class="form-check-label" for="payCashTurns">Puede abonar en efectivo</label>
                        </div> 
                        <div class="form-check form-switch mb-3">
                            <input class="form-check-input" type="checkbox" id="payCashTurns" name="payCashTurns" v-model="payCashTurns" @change="updatePaymentOptions()" :disabled="disabledPayCash" style="width: 2em;">
                            <label class="form-check-label" for="payCashTurns">Puede abonar con transferencia</label>
                        </div> 
                        <div class="form-check form-switch mb-3">
                            <input class="form-check-input" type="checkbox" id="notifyDebt" name="notifyDebt" v-model="notifyDebt" @change="updatePaymentOptions()" style="width: 2em;">
                            <label class="form-check-label" for="notifyDebt">Notificar de deuda al consultante</label>
                        </div> 
                        
                        <div v-show="bankAdded == '' && payCashTurns && hideDetails" class="bank-form-turn">
                            <h5 class="text-center">Datos Bancarios:</h5>
                            <form-user-bank v-if="payCashTurns == true" :hideDetails="hideDetails"></form-user-bank>
                        </div>
                       
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
    <div class="mx-auto position-fixed bottom-0 end-0 start-0 end-0 p-0 pt-3 pb-3" style="z-index: 118; width: fit-content;">
        <div id="toastcontainer" class="w-25">
        </div>
    </div>
</template>
<script>
import formUserBank from '@/components/my-account/form-user-bank.vue'

import axios from "axios";
import { Toast } from 'bootstrap'

let url;
export default { 
    name: "balances-prof",
    props: ['userSelected', 'userMode', 'showAll', 'showName', 'textButton', 'hideDetails', 'modality', 'cosnCountry'],
    components:{
        formUserBank
    },
    data(){
        return{
            errorText: '',
            toastColor: '',
            toastBg: '',
            toastNumber: 0,
            balances: [],
            wallets: [],
            userSel: this.userSelected,
            userModeSel: this.userMode,
            showAllSel: this.showAll,
            localZone: '',
            dataReceiver: '',
  
            //pay: false,
            hidecontent: false,
            publicKey: '',
            userName: '',
            sellerId: '',
            //buttonPasarela: '',
            result: '',
            payCardTurns: true,
            payCashTurns: false,
            payMoneyTurns: true,
            disabledPayCard: false, //si no es de argentina mexico chile o usa y no configuro la pasarela se deshabilita
            disabledPayCash: false, //si no es de argentina mexico chile o usa y no configuro la pasarela se deshabilita
            disabledPayMoney: false,
            notifyDebt: true,
            bankName: '',
            cbu: '',
            doc: '',
            titular: '',
            showBankData: false,
            profCountry:  '',
            contactCountry: '',
            profCurrency: '',
            userName: '',
            classShowDetails: 'col-lg-12',
            bankAdded: 'no', 
            displayMethods: false,
        }
    },
    mounted: function () {
        
        if(window.location.host == 'h.animasana.net' || window.location.host == 'animasana.net'){
            url = 'https://api.animasana.net'
        }else if(window.location.host == 'api-qa.animasana.net'){
            url = 'https://api-qa.animasana.net' 
        }else{
            url = 'https://api-qa.animasana.net'
        } 
        
        const plugin = document.createElement("script");
        plugin.setAttribute("src", "https://cdn.jsdelivr.net/npm/moment@2.30.1/min/moment.min.js");
        plugin.setAttribute("id", "momentScript");
        plugin.async = false;
        document.head.appendChild(plugin);
        const plugin2 = document.createElement("script");
        plugin2.setAttribute("src", "https://cdnjs.cloudflare.com/ajax/libs/moment-timezone/0.6.5/moment-timezone-with-data-10-year-range.min.js");
        plugin2.setAttribute("id", "momentScriptYears");
        plugin2.async = false;
        document.head.appendChild(plugin2);
        plugin.onload = () => {
            plugin2.onload = () => {
                this.localZone =  moment.tz.guess();
                if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
                    this.dataReceiver = localStorage.getItem('corporativeIn');
                }else{
                    this.dataReceiver = localStorage.getItem('token');
                }
                if(this.userSelected != ''){
                    this.findUserData();      
                }
            }
        }   
    },
    methods:{
        async findUserData(){    
            var payload = {
                action: 'find-user-data',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.userSelected,      
            }     
            await axios.post('/index.php', payload).then(result => {  
                this.contactCountry = result.data.userCountry;
                this.userName = result.data.userFirstName + ' ' + result.data.userLastName;
                this.findUserCurrency();
                this.findBalance();
                this.finPayments(); 
                this.listBilling();
            })
            .catch(error => {
            
            })          
        },
        async findUserCurrency(){
            var data = JSON.parse(localStorage.getItem('userData'));
            this.profCountry = data.userCountry;
            var payload = {
                action: 'find-currency',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                userCountry: this.profCountry     
            }
            await axios.post('/index.php', payload)
            .then(result => {             
                if(this.contactCountry == this.profCountry){
                    this.profCurrency = result.data[0].name;
                }else{
                    this.profCurrency = 'USD';
                }       
            })
            .catch(error => {
                this.loading = false;
                this.disabled = false;
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }	
                return;
            })
        },


        
        
        
        
        async saveAutoPay(currency){
            var payload = {
                action: 'save-auto-payments',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver, 
                mode: this.userModeSel,
                balanceOfUser: this.userSelected, 
                currency: currency,
                timezone: this.localZone
            }
            await axios.post('/index.php', payload).then(result => {
                this.findBalance();
                this.finPayments();
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }		
                return;
            })
        },

        async findBalance(){ 
            this.balances = [];
            var payload = {
                action: 'find-balances',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver, 
                mode: this.userModeSel,
                showAll: this.showAllSel,
                balanceOfUser: this.userSelected, 
                timezone: this.localZone
            }
            await axios.post('/index.php', payload).then(result => {
                if(result.data.length > 0){
                    if(result.data[0].saldo > 0 && result.data[0].saldo > result.data[0].ammount){
                        this.saveAutoPay(result.data[0].currency);
                        return
                    }
                    try{
                        this.$parent.showDeuda(true);
                    }
                    catch(error){

                    }
                }else{
                    try{
                        this.$parent.showDeuda(false);
                    }
                    catch(error){

                    }
                }
                this.balances = result.data;  
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }			
                return;
            })
        },
        async finPayments(){ 
            this.balances = [];
            var payload = {
                action: 'find-wallets',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver, 
                mode: this.userModeSel,
                showAll: this.showAllSel,
                dataReceiver: this.dataReceiver,
                balanceOfUser: this.userSelected, 
                timezone: this.localZone
            }
            await axios.post('/index.php', payload).then(result => {
                this.wallets = result.data;   
                this.findLobalPayments();
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }		
                return;
            })
        },
        async findLobalPayments(){  
            var payload = {
                action: 'find-local-payments',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver
            }
            await axios.post('/index.php', payload)
            .then(result => {
                if(result.data.status == '200'){
                     if(result.data.secretKey == "" && result.data.publicKey == ""){ //si no tiene las keys
                        //si son de los paises que animasana cuenta con pasarela
                        if(result.data.userCountry == '42' || result.data.userCountry == '81' || result.data.userCountry == '55' || result.data.userCountry == '103'){
                            this.payCashTurns = true;
                            this.disabledPayCash = false;
                            this.disabledPayCard = false;
                        }else{ 
                            this.payCardTurns = false;
                            this.payCashTurns = true;
                            this.disabledPayCash = true;
                            this.disabledPayCard = true;
                            //this.updatePaymentOptions();
                        }
                     }else{
                        //si tiene las keys
                         if(result.data.checked == true){ //si esta chequeadas las keys
                            //this.payCashTurns = true;
                            this.disabledPayCash = false;
                            this.disabledPayCard = false;
                         }else{
                            //si no estan chequeadas
                            //si son de los paises de animasana no pasa nada 
                            if(result.data.userCountry == '42' || result.data.userCountry == '81' || result.data.userCountry == '55' || result.data.userCountry == '103'){ 
                                this.payCashTurns = true;
                                this.disabledPayCash = false;
                                this.disabledPayCard = false;
                            }else{
                                //sino se desactiva la pasarela de tarjetas
                                this.payCashTurns = true;
                                this.payCardTurns = false;
                                this.disabledPayCash = true;
                                this.disabledPayCard = true;
                                //this.updatePaymentOptions();
                            }   
                         }
                     } 
                     if(this.hideDetails){
                        if(this.cosnCountry != result.data.userCountry){ 
                            this.payCardTurns = true;
                            this.payCashTurns = false;
                            this.payMoneyTurns = false;
                            this.disabledPayCash = true;
                            this.disabledPayMoney = true;
                            //this.updatePaymentOptions();
                        }
                    }
                     if(this.modality == '1' && this.hideDetails){
                        this.payMoneyTurns = false;
                        this.disabledPayMoney = true;
                        //this.updatePaymentOptions();
                     }
                }   
                this.findPaymentOptions();
            })
            .catch(error => {
                this.loading = false;
                this.disabled = false;
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }		
                return;
            })
        },
        async findPaymentOptions(){    
            var payload = {
                action: 'find-user-payment-options',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                mode: this.userModeSel,     
                dataReceiver: this.dataReceiver,
                balanceOfUser: this.userSelected,    
            }
            await axios.post('/index.php', payload).then(result => {
                if(result.data.status == '200'){
                    if(result.data.payCash == 0){
                        this.payCashTurns = false;
                    }else{
                        this.payCashTurns = true;
                    }
                    if(result.data.payMoney == 0){
                         this.payMoneyTurns = false;
                    }else{
                        this.payMoneyTurns = true;
                    }
                    if(result.data.payCard == 0){
                         this.payCardTurns = false;
                    }else{
                        if(this.disabledPayCard == true){
                            this.payCardTurns = false;
                        }   
                    } 
                    if(result.data.notifyDebt == 0){
                         this.notifyDebt = true;
                    }else{   
                        this.notifyDebt = false; 
                    } 

                    
                    this.displayMethods = true;
                    if(this.hideDetails){
                        if(this.modality == '1' && this.hideDetails){
                            this.payMoneyTurns = false;
                            this.disabledPayMoney = true;
                            //this.updatePaymentOptions();
                        }
                        this.sendTypePayments();
                    }
                    
                }
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }		
                return;
            })
        },
        async updatePaymentOptions(){   
            if(this.payCashTurns == false && this.payCardTurns == false){
                //this.payCashTurns = true;
            } 
            var payload = {
                action: 'update-user-payment-options',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver,     
                balanceOfUser: this.userSelected,  
                payCash: this.payCashTurns,
                payCard: this.payCardTurns,
                payMoney: this.payMoneyTurns,
                notifyDebt: this.notifyDebt
            }
            await axios.post('/index.php', payload).then(result => {
                if(result.data.status == '200'){
                    if(!this.hideDetails){   
                        this.errorText = 'Metodos de pagos actualizados para el usuario.';
                        this.toastBg = 'bg-info';
                        this.toastColor = 'text-dark';
                        this.toastNumber++;
                        var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                        try{
                            document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                            var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                            var bsAlert = new Toast(myAlert);//inizialize it
                            bsAlert.show();//show it
                        }catch(e){

                        }	
                    }else{
                        this.sendTypePayments();
                    }	
                    this.findPaymentOptions();
                }
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }		
                return;
            })
        },
        sendTypePayments(){
            this.$parent.sendTypePayments(this.payCashTurns, this.payCardTurns)
        },
        sendDataChange(userCountryBank, userFirstName, userLastName, userTypeBank, userBankName, userCurrencyBank, userCbuBank, userAliasBank, cbuText, bankAdded){
            this.bankAdded = bankAdded;
            this.$parent.sendDataChange(userCountryBank, userFirstName, userLastName, userTypeBank, userBankName, userCurrencyBank, userCbuBank, userAliasBank, cbuText)
        },
        
    }
}
</script>
<style scoped>
.w-fit-content{
    width: fit-content;
}
.bank-form-turn{
    border: 1px solid #ddd;
    padding: 10px;
    margin-bottom: 20px;
    border-radius: 5px;
    background: #f8f9fa;
}
</style>